(function () {
  function applyRatio(section, video, varName) {
    function update() {
      if (!video.videoWidth || !video.videoHeight) return;
      section.style.setProperty(varName, video.videoWidth / video.videoHeight);
    }

    if (video.readyState >= 1) {
      update();
    } else {
      video.addEventListener('loadedmetadata', update);
    }
  }

  function init() {
    var sections = document.querySelectorAll('.full-width-video-image.media-height');

    sections.forEach(function (section) {
      var desktopVideo = section.querySelector('.full-width-video-image__video-desktop video');
      var mobileVideo = section.querySelector('.full-width-video-image__video-mobile video');

      if (desktopVideo) applyRatio(section, desktopVideo, '--fwvi-desktop-ratio');
      if (mobileVideo) applyRatio(section, mobileVideo, '--fwvi-mobile-ratio');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
